import * as actionTypes from '../actions/actionTypes';
import {
    updateObject
} from '../../shared/utility';

const initialState = {
    qoe: [],
    qoeScores:[],
    qoeSuccess: false,
    qoeFailed: false,
    qoeLoaded: false,
    qoeScoresSuccess: false,
    qoeScoresFailed: false,
    qoeScoresLoaded: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        
        case actionTypes.GET_QOE_SUCCESS:
            return updateObject(state, {
                qoe: action.payload,
                qoeSuccess: true,
                qoeFailed: false,
                qoeLoaded: true
            });
        case actionTypes.GET_QOE_FAILED_RESET:
            return updateObject(state, {
                qoe: [],
                qoeSuccess: false,
                qoeFailed: false,
                qoeLoaded: false
            });
        case actionTypes.GET_QOE_FAILED:
            return updateObject(state, {
                qoe: [],
                qoeSuccess: false,
                qoeFailed: true,
                qoeLoaded: true
            });
        case actionTypes.GET_QOE_SCORES_SUCCESS:
            return updateObject(state, {
                qoeScores: action.payload,
                qoeScoresSuccess: true,
                qoeScoresFailed: false,
                qoeScoresLoaded: true
            });
        case actionTypes.GET_QOE_SCORES_FAILED:
            return updateObject(state, {
                qoeScores: [],
                qoeScoresSuccess: false,
                qoeScoresFailed: true,
                qoeScoresLoaded: true
            });
        default: return state;
    }
}

export default reducer;